(function () {

  /* =========================================================
     CREATE STRETCH EFFECT
  ========================================================= */

  function buildStretchLink(element) {

    if (!element) {
      return;
    }


    /* =====================================================
       PREVENT DUPLICATE INITIALIZATION
    ===================================================== */

    if (
      element.dataset
        .furStretchInitialized ===
      'true'
    ) {
      return;
    }


    /* =====================================================
       IGNORE COMPLEX MEDIA LINKS
    ===================================================== */

    if (
      element.querySelector(
        'img, svg, video, model-viewer'
      )
    ) {
      return;
    }


    /* =====================================================
       ORIGINAL TEXT
    ===================================================== */

    const originalText =
      element.textContent
        .replace(
          /\s+/g,
          ' '
        )
        .trim();


    if (!originalText) {
      return;
    }


    /* =====================================================
       SPLIT PREFIX + LAST WORD

       SHOP ALL

       prefix:
       "SHOP "

       lastWord:
       "ALL"
    ===================================================== */

    const words =
      originalText.split(' ');


    const lastWord =
      words.pop();


    if (!lastWord) {
      return;
    }


    let prefix =
      '';


    if (words.length) {

      prefix =
        words.join(' ') +
        ' ';

    }


    /* =====================================================
       FINAL CHARACTER

       ALL       → L
       SHOP      → P
       CONTACT   → T
       COLLECTION → N
    ===================================================== */

    const finalCharacter =
      Array.from(
        lastWord
      ).pop();


    if (!finalCharacter) {
      return;
    }


    /* =====================================================
       MARK INITIALIZED
    ===================================================== */

    element.dataset
      .furStretchInitialized =
      'true';


    element.classList.add(
      'fur-stretch-link'
    );


    /* =====================================================
       ACCESSIBILITY
    ===================================================== */

    if (
      !element.hasAttribute(
        'aria-label'
      )
    ) {

      element.setAttribute(
        'aria-label',
        originalText
      );

    }


    /* =====================================================
       STORE ORIGINAL TEXT

       Useful for reset().
    ===================================================== */

    element.dataset
      .furOriginalText =
      originalText;


    /* =====================================================
       CLEAR OLD MARKUP
    ===================================================== */

    element.innerHTML =
      '';


    /* =====================================================
       ORIGINAL VERSION
    ===================================================== */

    const original =
      document.createElement(
        'span'
      );


    original.className =
      'fur-stretch-link__original';


    original.textContent =
      originalText;


    element.appendChild(
      original
    );


    /* =====================================================
       HOVER VERSION
    ===================================================== */

    const hover =
      document.createElement(
        'span'
      );


    hover.className =
      'fur-stretch-link__hover';


    hover.setAttribute(
      'aria-hidden',
      'true'
    );


    /* =====================================================
       PREFIX
    ===================================================== */

    if (prefix) {

      const prefixElement =
        document.createElement(
          'span'
        );


      prefixElement.className =
        'fur-stretch-link__prefix';


      prefixElement.textContent =
        prefix;


      hover.appendChild(
        prefixElement
      );

    }


    /* =====================================================
       FINAL WORD
    ===================================================== */

    const word =
      document.createElement(
        'span'
      );


    word.className =
      'fur-stretch-link__word';


    /* =====================================================
       RED ROUGH MARKER

       Add BEFORE the text so CSS can put it
       visually behind everything.
    ===================================================== */

    const marker =
      document.createElement(
        'span'
      );


    marker.className =
      'fur-stretch-link__marker';


    marker.setAttribute(
      'aria-hidden',
      'true'
    );


    word.appendChild(
      marker
    );


    /* =====================================================
       BASE WORD
    ===================================================== */

    const baseWord =
      document.createElement(
        'span'
      );


    baseWord.className =
      'fur-stretch-link__base';


    baseWord.textContent =
      lastWord;


    word.appendChild(
      baseWord
    );


    /* =====================================================
       ADD THREE EXTRA FINAL CHARACTERS

       ALL

       + L
       + L
       + L

       = ALLLLL
    ===================================================== */

    for (
      let index = 1;
      index <= 3;
      index += 1
    ) {

      const extra =
        document.createElement(
          'span'
        );


      extra.className =
        'fur-stretch-link__extra ' +
        'fur-stretch-link__extra--' +
        index;


      extra.textContent =
        finalCharacter;


      word.appendChild(
        extra
      );

    }


    /* =====================================================
       ROUGH WHITE LINE 1
    ===================================================== */

    const line1 =
      document.createElement(
        'span'
      );


    line1.className =
      'fur-stretch-link__line ' +
      'fur-stretch-link__line--1';


    line1.setAttribute(
      'aria-hidden',
      'true'
    );


    word.appendChild(
      line1
    );


    /* =====================================================
       ROUGH WHITE LINE 2
    ===================================================== */

    const line2 =
      document.createElement(
        'span'
      );


    line2.className =
      'fur-stretch-link__line ' +
      'fur-stretch-link__line--2';


    line2.setAttribute(
      'aria-hidden',
      'true'
    );


    word.appendChild(
      line2
    );


    /* =====================================================
       FINISH HOVER VERSION
    ===================================================== */

    hover.appendChild(
      word
    );


    element.appendChild(
      hover
    );

  }



  /* =========================================================
     RESET / DYNAMIC TEXT

     Used elsewhere in your theme, for example:

     ADD TO BAG
     ADDING...
     ADDED TO BAG
  ========================================================= */

  function resetStretchLink(
    element,
    text
  ) {

    if (!element) {
      return;
    }


    const nextText =
      text !== undefined &&
      text !== null
        ? String(text)
        : element.dataset
            .furOriginalText ||
          element.textContent;


    element.classList.remove(
      'fur-stretch-link'
    );


    element.removeAttribute(
      'data-fur-stretch-initialized'
    );


    delete element.dataset
      .furStretchInitialized;


    element.innerHTML =
      '';


    element.textContent =
      nextText;


    buildStretchLink(
      element
    );

  }



  /* =========================================================
     INITIALIZE
  ========================================================= */

  function initFurStretchLinks(root) {

    const context =
      root ||
      document;


    const elements =
      [];


    /* =====================================================
       ROOT ITSELF
    ===================================================== */

    if (
      context.matches &&
      context.matches(
        '[data-fur-stretch-link]'
      )
    ) {

      elements.push(
        context
      );

    }


    /* =====================================================
       CHILD ELEMENTS
    ===================================================== */

    if (
      context.querySelectorAll
    ) {

      context
        .querySelectorAll(
          '[data-fur-stretch-link]'
        )
        .forEach(
          function (element) {

            elements.push(
              element
            );

          }
        );

    }


    /* =====================================================
       BUILD
    ===================================================== */

    elements.forEach(
      buildStretchLink
    );

  }



  /* =========================================================
     EXPOSE GLOBAL API

     Your other theme files already call:

     FurStretchLinks.init(...)
     FurStretchLinks.reset(...)
  ========================================================= */

  window.FurStretchLinks = {

    init:
      initFurStretchLinks,

    reset:
      resetStretchLink,

    build:
      buildStretchLink

  };



  /* =========================================================
     NORMAL PAGE LOAD
  ========================================================= */

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      function () {

        initFurStretchLinks(
          document
        );

      }
    );

  } else {

    initFurStretchLinks(
      document
    );

  }



  /* =========================================================
     SHOPIFY THEME EDITOR
  ========================================================= */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      initFurStretchLinks(
        event.target
      );

    }
  );



  /* =========================================================
     DYNAMIC SHOPIFY CONTENT

     Useful for:
     - related products loaded by AJAX
     - search products
     - dynamically rendered sections
  ========================================================= */

  const observer =
    new MutationObserver(
      function (mutations) {

        mutations.forEach(
          function (mutation) {

            mutation.addedNodes
              .forEach(
                function (node) {

                  if (
                    node.nodeType !==
                    1
                  ) {
                    return;
                  }


                  initFurStretchLinks(
                    node
                  );

                }
              );

          }
        );

      }
    );


  if (
    document.documentElement
  ) {

    observer.observe(
      document.documentElement,
      {
        childList: true,
        subtree: true
      }
    );

  }

})();